export const communicationsDashboardPageRootUrl = '/dashboard';

export const commsActivitySubPageUrl = `/comms-activity`;
export const commsActivityFeaturedConversationsSubPageUrl = `/comms-activity/featured-conversations`;
export const digitalSafetySubPageUrl = `/advanced-moderation`;
export const leadersAndAudiencesSubPageUrl = `/leaders-and-audiences`;
export const leadersActivityLogSugPageUrl = `/leaders-and-audiences/activity-log`;
export const conversationsSugPageUrl = `/conversations`;
export const projectsSubPageUrl = `/projects`;

export const communicationsDashboardPageUrl: string = `${communicationsDashboardPageRootUrl}${commsActivitySubPageUrl}`;
export const communicationsDashboardFeaturedConversationsUrl: string = `${communicationsDashboardPageRootUrl}${commsActivityFeaturedConversationsSubPageUrl}`;
export const communicationsDashboardDigitalSafetyPageUrl: string = `${communicationsDashboardPageRootUrl}${digitalSafetySubPageUrl}`;
export const communicationsDashboardLeadersAndAudiencesPageUrl: string = `${communicationsDashboardPageRootUrl}${leadersAndAudiencesSubPageUrl}`;
export const communicationsDashboardLeadersActivityLogPageUrl: string = `${communicationsDashboardPageRootUrl}${leadersActivityLogSugPageUrl}`;
export const communicationsDashboardConversationsPageUrl: string = `${communicationsDashboardPageRootUrl}${conversationsSugPageUrl}`;
export const communicationsDashboardProjectsPageUrl: string = `${communicationsDashboardPageRootUrl}${projectsSubPageUrl}`;
